module.exports = __webpack_public_path__ + "static/media/golfer-5-a.fa353311.png";